'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var styles = require('@material-ui/core/styles');
require('typeface-lato');
require('typeface-montserrat');
var CssBaseline = require('@material-ui/core/CssBaseline');
var core = require('@material-ui/core');
var Drawer = require('@material-ui/core/Drawer');
var List = require('@material-ui/core/List');
var ChevronLeftIcon = require('@material-ui/icons/ChevronLeft');
var ChevronRightIcon = require('@material-ui/icons/ChevronRight');
var clsx = require('clsx');
var ListItem = require('@material-ui/core/ListItem');
var ListItemIcon = require('@material-ui/core/ListItemIcon');
var Tooltip = require('@material-ui/core/Tooltip');
var colors$1 = require('@material-ui/core/colors');
var ArrowDropDownIcon = require('@material-ui/icons/ArrowDropDown');
var NotificationsNoneIcon = require('@material-ui/icons/NotificationsNone');
var Swal = require('sweetalert2');
var withReactContent = require('sweetalert2-react-content');
var CloseIcon = require('@material-ui/icons/Close');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var CssBaseline__default = /*#__PURE__*/_interopDefaultLegacy(CssBaseline);
var Drawer__default = /*#__PURE__*/_interopDefaultLegacy(Drawer);
var List__default = /*#__PURE__*/_interopDefaultLegacy(List);
var ChevronLeftIcon__default = /*#__PURE__*/_interopDefaultLegacy(ChevronLeftIcon);
var ChevronRightIcon__default = /*#__PURE__*/_interopDefaultLegacy(ChevronRightIcon);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var ListItem__default = /*#__PURE__*/_interopDefaultLegacy(ListItem);
var ListItemIcon__default = /*#__PURE__*/_interopDefaultLegacy(ListItemIcon);
var Tooltip__default = /*#__PURE__*/_interopDefaultLegacy(Tooltip);
var ArrowDropDownIcon__default = /*#__PURE__*/_interopDefaultLegacy(ArrowDropDownIcon);
var NotificationsNoneIcon__default = /*#__PURE__*/_interopDefaultLegacy(NotificationsNoneIcon);
var Swal__default = /*#__PURE__*/_interopDefaultLegacy(Swal);
var withReactContent__default = /*#__PURE__*/_interopDefaultLegacy(withReactContent);
var CloseIcon__default = /*#__PURE__*/_interopDefaultLegacy(CloseIcon);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var ATag = react.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (jsxRuntime.jsx("a", __assign({ ref: ref }, props, { children: children }), void 0));
});

var colors = {
    primaryMain: '#0FD2CB',
    primaryDark: '#00BFB3',
    primaryLight: '#03EFD7',
    secondaryMain: '#4B55A1',
    secondaryDark: '#3F4787',
    secondaryLight: '#5563C8',
    errorMain: '#F3455D',
    errorDark: '#F12D48',
    errorLight: '#F9586D',
    warningMain: '#FFD05B',
    warningDark: '#FFB328',
    warningLight: '#FFDC85',
    successMain: '#27AE60',
    successDark: '#219653',
    successLight: '#6FCF97',
    textMain: '#535353',
    textDark: '#363636',
    textLight: '#929292',
    primaryBg: '#FFFFFF',
    secondaryBg: '#EFEFEF'
};

var palette = function () { return ({
    primary: {
        main: colors.primaryMain,
        dark: colors.primaryDark,
        light: colors.primaryLight,
        contrastText: '#FFFFFF'
    },
    secondary: {
        main: colors.secondaryMain,
        dark: colors.secondaryDark,
        light: colors.secondaryLight,
    },
    error: {
        main: colors.errorMain,
        dark: colors.errorDark,
        light: colors.errorLight
    },
    warning: {
        main: colors.warningMain,
        dark: colors.warningDark,
        light: colors.warningLight
    },
    success: {
        main: colors.successMain,
        dark: colors.successDark,
        light: colors.successLight
    },
    text: {
        primary: colors.textDark,
        secondary: colors.textMain,
        disabled: colors.textLight,
    }
}); };

var MuiButton = function () { return ({
    containedPrimary: {
        '&:hover': {
            boxShadow: '0px 12px 15px rgba(15, 210, 203, 0.2)'
        }
    },
    containedSecondary: {
        '&:hover': {
            boxShadow: '0px 12px 15px rgba(75, 85, 161, 0.2)'
        }
    },
    contained: {
        boxShadow: 'none',
        "&$disabled": {
            color: '#FFFFFF'
        },
    },
    outlined: {
        "&$disabled": {
            backgroundColor: colors.secondaryBg
        }
    },
    root: {
        fontWeight: "bold",
        textTransform: "initial",
        borderRadius: 6,
    }
}); };

var MuiCheckbox$1 = function () { return ({
    colorPrimary: {
        color: colors.primaryMain
    },
    colorSecondary: {
        color: colors.secondaryMain
    },
    root: {
        "&$disabled": {
            "& .MuiIconButton-label": {
                width: "1.125rem",
                height: "1.125rem",
                margin: "3px",
                borderRadius: "2px",
                overflow: "hidden"
            },
            "& .MuiSvgIcon-root": {
                backgroundColor: colors.secondaryBg
            }
        }
    }
}); };

var MuiRadio = function () { return ({
    colorPrimary: {
        color: colors.primaryMain
    },
    colorSecondary: {
        color: colors.secondaryMain
    },
    root: {
        "&$disabled": {
            "& .MuiIconButton-label": {
                width: "1.25rem",
                height: "1.25rem",
                margin: "0.1255rem",
                borderRadius: "50%",
                overflow: "hidden"
            },
            "& .MuiSvgIcon-root": {
                backgroundColor: colors.secondaryBg
            }
        }
    }
}); };

var MuiSwitch = function () { return ({
    colorPrimary: {
        "& .MuiSwitch-thumb": {
            borderColor: colors.primaryMain
        },
        "& + .MuiSwitch-track": {
            borderColor: colors.primaryMain
        },
        "&$checked": {
            color: "#FFFFFF"
        }
    },
    colorSecondary: {
        "& .MuiSwitch-thumb": {
            borderColor: colors.secondaryMain
        },
        "& + .MuiSwitch-track": {
            borderColor: colors.secondaryMain
        },
        "&$checked": {
            color: "#FFFFFF",
        }
    },
    root: {
        padding: "0.25rem 0",
        margin: "0.688rem 0.75rem 0.938rem 0.75rem",
        height: "2rem",
        "& .MuiButtonBase-root": {
            padding: "0.5rem 0.5rem 0.5rem 0.438rem",
            marginTop: "0"
        }
    },
    track: {
        borderRadius: "12px",
        opacity: 1,
        backgroundColor: "#FFFFFF",
        border: "0.125rem solid " + colors.textLight
    },
    thumb: {
        width: "1rem",
        height: "1rem",
        boxShadow: "none",
        border: "0.125rem solid " + colors.textLight
    },
    switchBase: {
        color: "#FFFFFF",
        "&$checked": {
            transform: "translateX(29px)",
            "& + .MuiSwitch-track": {
                opacity: 1
            },
            "& .MuiSwitch-thumb": {
                borderColor: "#FFFFFF"
            }
        },
        "&$disabled": {
            color: "#FFFFFF",
            "& + .MuiSwitch-track": {
                opacity: 1
            },
            "&$checked": {
                "& .MuiSwitch-thumb": {
                    borderColor: colors.textLight
                },
                "& + .MuiSwitch-track": {
                    backgroundColor: colors.secondaryBg
                }
            }
        }
    }
}); };

var MuiAlert = function () { return ({
    root: {
        fontSize: '1rem',
        lineHeight: '28px',
        padding: '8px 16px',
        borderRadius: '6px'
    },
    standardError: {
        color: colors.errorMain,
        backgroundColor: colors.errorMain + '33'
    },
    standardInfo: {
        color: colors.primaryBg,
        backgroundColor: colors.textDark,
        "& .MuiAlert-message": {
            color: colors.primaryBg
        }
    },
    standardSuccess: {
        color: colors.primaryDark,
        backgroundColor: colors.successMain + '33'
    },
    standardWarning: {
        color: colors.warningMain,
        backgroundColor: colors.warningMain + '33'
    },
    message: {
        color: colors.textMain
    }
}); };

var MuiAvatar = function () { return ({
    root: {
        width: '24px',
        height: '24px'
    }
}); };

var MuiCard = function () { return ({
    root: {
        borderRadius: '12px',
        boxShadow: '0px 16px 16px rgba(54, 54, 54, 0.08)'
    }
}); };

var MuiCardActions = function () { return ({
    root: {
        padding: '12px 30px 30px 30px',
        flexDirection: 'row-reverse'
    }
}); };

var MuiCardContent = function () { return ({
    root: {
        padding: '12px 40px 12px 40px'
    },
}); };

var MuiCardHeader = function () { return ({
    root: {
        padding: '40px 40px 12px 40px'
    },
    title: {
        fontSize: '0.875rem'
    }
}); };

var MuiChip = function () { return ({
    root: {
        height: '38px',
        borderRadius: '6px',
        marginRight: '8px',
        fontFamily: 'inherit',
        fontSize: '0.875rem'
    },
    deleteIcon: {
        width: '18px',
        height: '18px',
        color: colors.primaryDark,
        "&.MuiSvgIcon-colorSecondary": {
            color: colors.secondaryDark
        }
    }
}); };

var MuiFormHelperText = function () { return ({
    root: {
        marginTop: '11px',
        fontSize: '0.875rem',
        lineHeight: '1.25rem'
    },
    contained: {
        marginLeft: 0,
        marginRight: 0
    }
}); };

var MuiFormLabel = function () { return ({
    root: {
        lineHeight: '1.75rem',
    },
}); };

var MuiInputBase = function () { return ({
    root: {
        border: "1px solid rgba(0, 0, 0, 0.23)",
        borderRadius: "inherit",
        "&.Mui-error": {
            borderColor: colors.errorMain
        },
        "& .MuiInputAdornment-root .MuiSvgIcon-root": {
            fill: colors.primaryMain
        },
        "&.Mui-error .MuiInputAdornment-root .MuiSvgIcon-root": {
            fill: colors.errorMain
        },
        "&.Mui-focused": {
            borderColor: colors.primaryMain,
        },
        "&.Mui-focused .MuiInputAdornment-root .MuiSvgIcon-root": {
            fill: colors.primaryMain
        },
        "&.Mui-disabled": {
            backgroundColor: colors.secondaryBg
        },
        "&.Mui-disabled .MuiInputAdornment-root .MuiSvgIcon-root": {
            fill: colors.textLight
        },
        "& .MuiSelect-icon": {
            color: colors.primaryMain
        },
        "& .MuiChip-root": {
            backgroundColor: colors.primaryMain + '33'
        }
    },
    colorSecondary: {
        "& .MuiInputAdornment-root .MuiSvgIcon-root": {
            fill: colors.secondaryMain
        },
        "&.Mui-focused": {
            borderColor: colors.secondaryMain,
        },
        "&.Mui-focused .MuiInputAdornment-root .MuiSvgIcon-root": {
            fill: colors.secondaryMain
        },
        "& .MuiSelect-icon": {
            color: colors.secondaryMain
        },
        "& .MuiChip-root": {
            backgroundColor: colors.secondaryMain + '33'
        }
    }
}); };

var MuiInputLabel$1 = function () { return ({
    root: {
        color: colors.textMain,
        transform: 'none !important',
        paddingBottom: "4px",
        "&$focused, &.Mui-disabled": {
            color: colors.textMain
        }
    },
    shrink: {
        transform: 'none'
    },
    formControl: {
        position: 'relative'
    },
}); };

var MuiList = function () { return ({
    padding: {
        paddingTop: 0,
        paddingBottom: 0
    },
    root: {
        "& .PrivateSwitchBase-root-9": {
            padding: '0 20px 0 0'
        }
    }
}); };

var MuiListItem = function () { return ({
    root: {
        paddingTop: '1.125rem',
        paddingBottom: '1.125rem',
        borderRadius: '6px'
    },
    gutters: {
        paddingLeft: '1.75rem',
        paddingRight: '1.75rem'
    }
}); };

var MuiOutlinedInput = function () { return ({
    notchedOutline: {
        display: "none"
    },
    input: {
        padding: "14px 28px"
    },
    root: {
        borderRadius: '6px'
    }
}); };

var MuiPaginationItem = function () { return ({
    root: {
        borderRadius: '6px',
        margin: '0 4px',
        height: '30px',
        minWidth: '30px'
    },
    page: {
        "&.Mui-selected": {
            backgroundColor: colors.primaryMain,
            color: '#FFFFFF',
            "&.Mui-selected:hover": {
                backgroundColor: colors.primaryMain,
            }
        },
    },
    textSecondary: {
        "&.Mui-selected": {
            backgroundColor: colors.secondaryMain,
            "&.Mui-selected:hover": {
                backgroundColor: colors.secondaryMain,
            }
        },
    }
}); };

var MuiSelect$1 = function () { return ({
    outlined: {
        "&.MuiSelect-outlined": {
            paddingRight: '3.5rem'
        }
    },
}); };

var MuiTooltip = function () { return ({
    tooltip: {
        fontSize: '0.875rem',
        padding: '7px 15px',
        lineHeight: '1.188rem',
        backgroundColor: colors.textDark,
        borderRadius: '6px'
    }
}); };

var overrides = function () { return ({
    MuiButton: MuiButton(),
    MuiCheckbox: MuiCheckbox$1(),
    MuiRadio: MuiRadio(),
    MuiSwitch: MuiSwitch(),
    MuiInputLabel: MuiInputLabel$1(),
    MuiFormLabel: MuiFormLabel(),
    MuiOutlinedInput: MuiOutlinedInput(),
    MuiInputBase: MuiInputBase(),
    MuiFormHelperText: MuiFormHelperText(),
    MuiListItem: MuiListItem(),
    MuiList: MuiList(),
    MuiSelect: MuiSelect$1(),
    MuiChip: MuiChip(),
    MuiAlert: MuiAlert(),
    MuiTooltip: MuiTooltip(),
    MuiPaginationItem: MuiPaginationItem(),
    MuiCard: MuiCard(),
    MuiCardHeader: MuiCardHeader(),
    MuiCardContent: MuiCardContent(),
    MuiCardActions: MuiCardActions(),
    MuiAvatar: MuiAvatar()
}); };

var MuiCheckbox = function () { return ({}); };

var MuiFormControl = function () { return ({
    variant: "outlined",
}); };

var MuiInputLabel = function () { return ({
    shrink: true
}); };

var MuiTextField = function () { return ({
    variant: "outlined",
}); };

var MuiSelect = function () { return ({
    MenuProps: {
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
        },
        getContentAnchorEl: null
    }
}); };

var props = function () { return ({
    MuiCheckbox: MuiCheckbox(),
    MuiFormControl: MuiFormControl(),
    MuiInputLabel: MuiInputLabel(),
    MuiTextField: MuiTextField(),
    MuiSelect: MuiSelect()
}); };

var typography = function () { return ({
    h1: {
        fontSize: '6rem',
        letterSpacing: '-1.5px',
        fontWeight: 600,
        fontFamily: "\"Montserrat\", \"Trebuchet MS\", Helvetica, sans-serif"
    },
    h2: {
        fontSize: '3.75rem',
        letterSpacing: '-0.5px',
        fontWeight: 600,
        fontFamily: "\"Montserrat\", \"Trebuchet MS\", Helvetica, sans-serif"
    },
    h3: {
        fontSize: '3rem',
        letterSpacing: '0px',
        fontWeight: 600,
        fontFamily: "\"Montserrat\", \"Trebuchet MS\", Helvetica, sans-serif"
    },
    h4: {
        fontSize: '1.813rem',
        letterSpacing: '0.25px',
        fontWeight: 600,
        fontFamily: "\"Montserrat\", \"Trebuchet MS\", Helvetica, sans-serif"
    },
    h5: {
        fontSize: '1.5rem',
        letterSpacing: '0px',
        fontWeight: 600,
        fontFamily: "\"Montserrat\", \"Trebuchet MS\", Helvetica, sans-serif"
    },
    h6: {
        fontSize: '1.25rem',
        letterSpacing: '0px',
        fontWeight: 600,
        fontFamily: "\"Montserrat\", \"Trebuchet MS\", Helvetica, sans-serif"
    },
    button: {
        fontSize: '0.875rem',
        letterSpacing: '0px',
        fontWeight: 600,
        fontFamily: "\"Montserrat\", \"Trebuchet MS\", Helvetica, sans-serif",
        textTransform: 'none'
    },
    subtitle1: {
        fontSize: '1rem',
        letterSpacing: '0px',
        fontWeight: 400,
        fontFamily: "\"Montserrat\", \"Trebuchet MS\", Helvetica, sans-serif"
    },
    subtitle2: {
        fontSize: '1rem',
        letterSpacing: '0px',
        fontWeight: 400,
        fontFamily: "\"Montserrat\", \"Trebuchet MS\", Helvetica, sans-serif"
    },
    body1: {
        fontSize: '1rem',
        letterSpacing: '0.6px',
        fontWeight: 400,
        fontFamily: "\"Lato\", Geneva, Tahoma, sans-serif"
    },
    body2: {
        fontSize: '0.875rem',
        letterSpacing: '0.6px',
        fontWeight: 400,
        fontFamily: "\"Lato\", Geneva, Tahoma, sans-serif"
    },
    caption: {
        fontSize: '0.75rem',
        letterSpacing: '0.6px',
        fontWeight: 400,
        fontFamily: "\"Lato\", Geneva, Tahoma, sans-serif"
    },
    overline: {
        fontSize: '0.625rem',
        letterSpacing: '1.5px',
        fontWeight: 400,
        fontFamily: "\"Lato\", Geneva, Tahoma, sans-serif"
    }
}); };

var HilabTheme = function (_a) {
    var children = _a.children;
    var theme = styles.createMuiTheme({
        palette: palette(),
        overrides: overrides(),
        props: props(),
        typography: typography(),
        globalMenuWidth: 240,
        globalMenuClosedWidth: 60,
        globalTopbarHeightIndex: 7.5,
    });
    return jsxRuntime.jsx(styles.ThemeProvider, __assign({ theme: theme }, { children: children }), void 0);
};

var makeListItemIcon = core.makeStyles(function (theme) { return ({
    root: {
        minWidth: "auto",
        marginRight: theme.spacing(2)
    },
    button: {
        paddingLeft: '22px',
        borderRadius: 0,
        color: colors.textLight,
        transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        "&:hover": {
            backgroundColor: colors.primaryDark + '0D',
            borderLeft: "4px solid " + colors.primaryMain,
            paddingLeft: '18px',
            "& .MuiTypography-root": {
                color: "#000000"
            }
        }
    },
    active: {
        backgroundColor: colors.primaryDark + '0D',
        borderLeft: "4px solid " + colors.primaryMain,
        paddingLeft: '18px',
        "& .MuiTypography-root": {
            color: "#000000"
        },
        "& .MuiIcon-root": {
            color: colors.primaryMain
        }
    }
}); });

var LinkItem = function (_a) {
    var _b;
    var link = _a.link, open = _a.open;
    var style = makeListItemIcon();
    var content = (jsxRuntime.jsxs(ListItem__default['default'], __assign({ className: clsx__default['default'](style.button, (_b = {},
            _b[style.active] = link.active,
            _b)), button: true, component: ATag, href: link.url }, { children: [jsxRuntime.jsx(ListItemIcon__default['default'], __assign({ className: style.root }, { children: link.icon }), void 0),
            jsxRuntime.jsx(core.Typography, __assign({ className: style.text, variant: "button" }, { children: link.title }), void 0)] }), void 0));
    if (!open) {
        return (jsxRuntime.jsx(Tooltip__default['default'], __assign({ title: link.title, placement: "right" }, { children: content }), void 0));
    }
    return (jsxRuntime.jsx(jsxRuntime.Fragment, { children: content }, void 0));
};

var makeMenu = function (hasGlobalTopbar) { return core.makeStyles(function (theme) { return ({
    drawer: {
        width: theme.globalMenuWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: theme.globalMenuWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.globalMenuClosedWidth,
    },
    toggle: {
        position: 'fixed',
        zIndex: 1000,
        top: "" + (hasGlobalTopbar ? (theme.spacing(theme.globalTopbarHeightIndex) + 18) + 'px' : '18px')
    },
    toggleOpen: {
        left: theme.globalMenuWidth - 12 + "px",
        transition: theme.transitions.create('left', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    toggleClose: {
        left: theme.globalMenuClosedWidth - 12 + "px",
        transition: theme.transitions.create('left', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    toggleButton: {
        backgroundColor: colors$1.grey[300],
        padding: 0,
        color: colors$1.grey[600],
        "&:hover": {
            backgroundColor: colors$1.grey[300]
        }
    }
}); }); };

var GlobalMenu = function (_a) {
    var _b, _c, _d;
    var hasGlobalTopbar = _a.hasGlobalTopbar, links = _a.links;
    var _e = react.useState(false), open = _e[0], setOpen = _e[1];
    var handleDrawer = function () {
        setOpen(!open);
    };
    var menu = makeMenu(hasGlobalTopbar)();
    return (jsxRuntime.jsxs(Drawer__default['default'], __assign({ className: clsx__default['default'](menu.drawer, (_b = {},
            _b[menu.drawerOpen] = open,
            _b[menu.drawerClose] = !open,
            _b)), variant: "permanent", anchor: "left", classes: {
            paper: clsx__default['default']((_c = {},
                _c[menu.drawerOpen] = open,
                _c[menu.drawerClose] = !open,
                _c)),
        } }, { children: [!!hasGlobalTopbar && jsxRuntime.jsx(core.Toolbar, {}, void 0),
            jsxRuntime.jsx("div", __assign({ className: clsx__default['default'](menu.toggle, (_d = {},
                    _d[menu.toggleOpen] = open,
                    _d[menu.toggleClose] = !open,
                    _d)) }, { children: jsxRuntime.jsx(core.IconButton, __assign({ size: "small", onClick: handleDrawer, className: menu.toggleButton }, { children: open ? jsxRuntime.jsx(ChevronLeftIcon__default['default'], {}, void 0) : jsxRuntime.jsx(ChevronRightIcon__default['default'], {}, void 0) }), void 0) }), void 0),
            jsxRuntime.jsx(List__default['default'], { children: links.map(function (link) { return (jsxRuntime.jsx(LinkItem, { open: open, link: link }, link.url)); }) }, void 0)] }), void 0));
};

var makeTopbar = core.makeStyles(function (theme) { return ({
    root: {
        zIndex: theme.zIndex.drawer + 1,
        "& .MuiToolbar-root": {
            minHeight: theme.spacing(theme.globalTopbarHeightIndex)
        }
    },
    grow: {
        flexGrow: 1
    },
    logoutButton: {
        marginLeft: theme.spacing(1)
    },
    iconImg: {
        marginRight: theme.spacing(2)
    },
    title: {
        fontFamily: 'Montserrat',
        fontWeight: 500,
        marginTop: '0.55rem',
        marginLeft: theme.spacing(0.5),
        fontSize: '0.875rem',
        textTransform: 'uppercase'
    },
    notificationIcon: {
        color: colors$1.grey[600]
    },
    end: {
        display: 'flex',
        alignItems: 'center'
    },
}); });

var GlobalTopbar = function (_a) {
    var title = _a.title, content = _a.content;
    var topbar = makeTopbar();
    return (jsxRuntime.jsx(core.AppBar, __assign({ position: "fixed", color: "inherit", className: topbar.root }, { children: jsxRuntime.jsxs(core.Toolbar, { children: [jsxRuntime.jsx("img", { className: topbar.iconImg, src: "/header_icon.svg", alt: "Icon" }, void 0),
                jsxRuntime.jsx("img", { src: "/logo.svg", alt: "Hilab" }, void 0),
                jsxRuntime.jsx(core.Typography, __assign({ component: "h2", className: topbar.title }, { children: title }), void 0),
                jsxRuntime.jsx("div", { className: topbar.grow }, void 0),
                jsxRuntime.jsxs("div", __assign({ className: topbar.end }, { children: [!!content && jsxRuntime.jsx("div", { children: content }, void 0),
                        jsxRuntime.jsx("div", { children: jsxRuntime.jsx(core.IconButton, __assign({ edge: "end", className: topbar.notificationIcon }, { children: jsxRuntime.jsx(NotificationsNoneIcon__default['default'], {}, void 0) }), void 0) }, void 0),
                        jsxRuntime.jsx("div", { children: jsxRuntime.jsxs(core.Button, __assign({ color: "inherit", className: topbar.logoutButton }, { children: [jsxRuntime.jsx(core.Avatar, {}, void 0),
                                    jsxRuntime.jsx(ArrowDropDownIcon__default['default'], {}, void 0)] }), void 0) }, void 0)] }), void 0)] }, void 0) }), void 0));
};

var LayoutWrapper = function (_a) {
    var hasGlobalTopbar = _a.hasGlobalTopbar, hasGlobalMenu = _a.hasGlobalMenu, links = _a.links, title = _a.title, topbarContent = _a.topbarContent;
    return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [hasGlobalTopbar && jsxRuntime.jsx(GlobalTopbar, __assign({}, { title: title, content: topbarContent }), void 0),
            hasGlobalMenu && jsxRuntime.jsx(GlobalMenu, __assign({}, { hasGlobalTopbar: hasGlobalTopbar, links: links }), void 0)] }, void 0));
};

var makeApp = function (hasGlobalTopbar, hasGlobalMenu) { return core.makeStyles(function (theme) { return ({
    root: {
        paddingLeft: !!hasGlobalMenu
            ? theme.globalMenuClosedWidth
            : 0,
    },
    content: {
        paddingTop: !!hasGlobalTopbar
            ? theme.spacing(theme.globalTopbarHeightIndex)
            : 0,
    },
    '@global': {
        '.MuiToolbar-root': {
            minHeight: theme.spacing(theme.globalTopbarHeightIndex)
        }
    }
}); }); };

var Layout = function (_a) {
    var children = _a.children, hasGlobalTopbar = _a.hasGlobalTopbar, hasGlobalMenu = _a.hasGlobalMenu, links = _a.links, title = _a.title, topbarContent = _a.topbarContent;
    var appStyle = makeApp(hasGlobalTopbar, hasGlobalMenu)();
    return (jsxRuntime.jsxs("div", __assign({ className: "App " + appStyle.root }, { children: [jsxRuntime.jsx(CssBaseline__default['default'], {}, void 0),
            jsxRuntime.jsx(LayoutWrapper, __assign({}, { hasGlobalTopbar: hasGlobalTopbar, hasGlobalMenu: hasGlobalMenu, links: links, title: title, topbarContent: topbarContent }), void 0),
            jsxRuntime.jsx("div", __assign({ className: appStyle.content }, { children: children }), void 0)] }), void 0));
};

var Alert = withReactContent__default['default'](Swal__default['default']);
var alertError = function (options) {
    Alert.fire(__assign({ buttonsStyling: false, customClass: {
            confirmButton: 'MuiButtonBase-root MuiButton-root MuiButton-contained errorContainedButton',
            cancelButton: 'MuiButtonBase-root MuiButton-root MuiButton-text errorTextButton modalButtonSpacing',
            denyButton: 'MuiButtonBase-root MuiButton-root MuiButton-outlined errorOutlinedButton modalButtonSpacing'
        } }, options));
};
var alertWarning = function (options) {
    Alert.fire(__assign({ buttonsStyling: false, customClass: {
            confirmButton: 'MuiButtonBase-root MuiButton-root MuiButton-contained warningContainedButton',
            cancelButton: 'MuiButtonBase-root MuiButton-root MuiButton-text warningTextButton modalButtonSpacing',
            denyButton: 'MuiButtonBase-root MuiButton-root MuiButton-outlined warningOutlinedButton modalButtonSpacing'
        } }, options));
};
var alertPrimary = function (options) {
    Alert.fire(__assign({ buttonsStyling: false, customClass: {
            confirmButton: 'MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary',
            cancelButton: 'MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary modalButtonSpacing',
            denyButton: 'MuiButtonBase-root MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary modalButtonSpacing'
        } }, options));
};
var alertSecondary = function (options) {
    Alert.fire(__assign({ buttonsStyling: false, customClass: {
            confirmButton: 'MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedSecondary',
            cancelButton: 'MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textSecondary modalButtonSpacing',
            denyButton: 'MuiButtonBase-root MuiButton-root MuiButton-outlined MuiButton-outlinedSecondary modalButtonSpacing'
        } }, options));
};

var useStyles = core.makeStyles({
    root: {
        "& .MuiSelect-root": {
            paddingTop: '9px',
            paddingBottom: '9px',
            minHeight: '29px'
        }
    }
});
var MultipleSelect = function (_a) {
    var label = _a.label, options = _a.options, color = _a.color, val = _a.val, onChange = _a.onChange;
    var classes = useStyles();
    var handleChange = function (event) {
        onChange(event.target.value);
    };
    var handleDelete = function (event, value) {
        var updatedValues = val.filter(function (el) { return el !== value; });
        onChange(updatedValues);
    };
    return (jsxRuntime.jsxs(core.FormControl, __assign({ color: color, "data-testid": "multiple-select" }, { children: [jsxRuntime.jsx(core.InputLabel, { children: label }, void 0),
            jsxRuntime.jsx(core.Select, __assign({ className: classes.root, multiple: true, value: val, onChange: handleChange, renderValue: function (selected) { return (jsxRuntime.jsx("div", { children: selected.map(function (value, index) { return (jsxRuntime.jsx(core.Chip, { label: value, deleteIcon: jsxRuntime.jsx(CloseIcon__default['default'], { "data-testid": 'multiple-delete-' + index, color: color, onMouseDown: function (event) { return event.stopPropagation(); } }, void 0), onDelete: function (e) { return handleDelete(e, value); } }, value)); }) }, void 0)); } }, { children: options.map(function (el, index) { return (jsxRuntime.jsxs(core.MenuItem, __assign({ value: el }, { children: [jsxRuntime.jsx(core.Checkbox, { color: color, checked: val.includes(el) }, void 0),
                        jsxRuntime.jsx(core.ListItemText, { primary: el }, void 0)] }), el)); }) }), void 0)] }), void 0));
};

var returnLibrary = function returnLibrary() {
  return {
    ATag: ATag,
    HilabTheme: HilabTheme,
    Layout: Layout,
    Alert: Alert,
    alertError: alertError,
    alertPrimary: alertPrimary,
    alertSecondary: alertSecondary,
    alertWarning: alertWarning,
    MultipleSelect: MultipleSelect
  };
};

var lib = returnLibrary();

module.exports = lib;
